import React from "react";
import Modal from "react-modal";
import "./Modal.css";
import "./CreateClubModal.css";
import "./TextInputModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Input from "../Input";
import SecButton from "../SecButton";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default class CreateClubModal extends React.Component<
  {
    show: boolean;
    handleClose: any;
    handleConfirm: any;
    loading: boolean;
    title: string;
    btnText: string;
  },
  { branchName: string; identifier: string; branchCount: number }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      branchName: "",
      identifier: "",
      branchCount: 0,
    };
  }

  handleBranchNameChange = (val: any) => {
    this.setState({ branchName: val });
  };

  handleBranchIdentifierChange = (val: any) => {
    this.setState({ identifier: val });
  };

  handleBranchCountChange = (val: any) => {
    this.setState({ branchCount: val });
  };

  render() {
    return (
      <>
        <Modal
          isOpen={this.props.show}
          contentLabel="create Branch"
          onRequestClose={() => {}}
          className="modal-size modal-background"
          ariaHideApp={false}
        >
          <div className="user-modal-inner">
            <div
              className="modal-cross-container"
              onClick={this.props.handleClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </div>
            <div className="modal-title-container">
              <span className="modal-title">{this.props.title}</span>
            </div>
            <Input
              name="text-input"
              placeholder="Vereinsname"
              value={this.state.branchName}
              onChange={this.handleBranchNameChange}
            />
            <Input
              name="text-input"
              placeholder="Subdomain"
              value={this.state.identifier}
              onChange={this.handleBranchIdentifierChange}
            />
            <Input
              name="number-input"
              placeholder="Anzahl der Sparten"
              value={this.state.branchCount}
              type="number"
              onChange={this.handleBranchCountChange}
            />
            <SecButton
              change={this.state.branchName.length !== 0}
              color="green"
              loading={this.props.loading}
              onClick={() => {
                this.props.handleConfirm(
                  this.state.branchName,
                  this.state.identifier,
                  this.state.branchCount
                );
              }}
              title={this.props.btnText}
            />
          </div>
        </Modal>
      </>
    );
  }
}
